"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveTabs = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const lib_1 = require("../lib");
const Wrap = (0, app_1.styled)(ui_1.Grid) `
  background-color: ${(theme) => theme.background};
  padding: calc(${(theme) => theme.spacing.extraLarge} * 2)
    ${(theme) => theme.spacing.extraLarge};
  @media ${app_1.notDesktop} {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    padding: calc(${(theme) => theme.spacing.small} * 2)
      ${(theme) => theme.spacing.small};
  }

  position: relative;
`;
const RichTextWrap = app_1.styled.div `
	position: relative;
	z-index: 1;

`;
const Content = (0, app_1.styled)(ui_1.GridItem) `
  max-width: 80%;
  display: block;
  margin: auto 0;
  grid-row: 1 / span ${(_, { $count }) => $count};
  grid-column: 2;
  @media ${app_1.notDesktop} {
    grid-column: 1;
    grid-row: ${(_, { $active }) => $active + 2};
  }

  &:after {
    position: absolute;
    content: '';
    inset: 0;
    background-image: url('${(_, { $url }) => $url}');
    background-position: center;
    background-size: cover;
    display: none;
  }
  &:hover:after {
    display: block;
    opacity: 0.25;
  }
  a {
    z-index: 1;
  }
`;
function InteractiveTabs({ tabs, pageId, }) {
    var _a, _b, _c;
    const [activeTab, setActiveTab] = (0, react_1.useState)(0);
    const isMobile = (0, app_1.useIsMobile)(1024);
    const activeTabData = (_a = tabs[activeTab]) === null || _a === void 0 ? void 0 : _a.data;
    const { url, ctaText, richText, image } = activeTabData;
    const imgUrl = `page/${pageId !== null && pageId !== void 0 ? pageId : ''}/${(_c = (_b = image === null || image === void 0 ? void 0 : image[0]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : ''}`;
    return ((0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ templateColumns: "minmax(0,1fr) minmax(0, 1fr)", gap: "big" }, { children: [tabs.map((v, i) => ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, Object.assign({ whileHover: isMobile ? {} : { x: 60 }, animate: isMobile ? {} : { x: activeTab === i ? 60 : 0 }, onClick: () => setActiveTab(i), style: { gridColumn: 1, zIndex: 1 } }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", as: "h3" }, { children: v.title })) }), v.title))), (0, jsx_runtime_1.jsx)(Content, Object.assign({ "$count": tabs.length, "$active": activeTab, "$url": imgUrl }, { children: (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(RichTextWrap, { children: (0, jsx_runtime_1.jsx)(lib_1.RichText, { value: richText !== null && richText !== void 0 ? richText : '', asMap: { h3: 'h4' } }) }), (0, jsx_runtime_1.jsx)("div", { children: url && ctaText ? ((0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ kind: "ghost", href: url }, { children: ctaText }))) : null })] })) }))] })));
}
exports.InteractiveTabs = InteractiveTabs;
